export default function (Component) {
      Component.options.__docs = "```\n<ds-placeholder>\n  Holding my ground\n</ds-placeholder>\n  ```"
    }